var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',_vm._b({staticClass:"btn",class:`btn-${_vm.color} ${_vm.computedSize} ${_vm.classes}`,attrs:{"type":_vm.type,"data-spec":_vm.dataSpec},on:{"click":_vm.onClick}},'button',_vm.$attrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }